import { CheckOutlined, PlusOutlined, RightOutlined } from '@ant-design/icons';
import { Button, Col, Divider, Row, Space, Switch, Tag, Typography } from 'antd';
import moment from 'moment';
import Image from 'next/image';
import Router, { useRouter } from 'next/router';
import { FC, useCallback, useEffect, useRef, useState } from 'react';
import { ResponsiveModal } from '../../../components/ResponsiveModal/ResponsiveModal';
import { useSubscriptionChangeModal } from '../../../components/SubscriptionModel/SubscriptionChangeModal';
import { useConnection } from '../../../connection/Application';
import { useCachedData } from '../../../connection/CacheContext';
import SLFlag from '../../../public/recruiter/recruiter-landing/SLFlag.png';
import USFlag from '../../../public/recruiter/recruiter-landing/USFlag.png';
import Utils from '../../../utils/Utils';
import stylesModule from './RecSubscriptionTable.module.less';
import RequestDemoModal, { RequestDemoInstance } from './RequestDemoModal';
const AvailablePackages = {
  payAsYouGo: '6f063c91-19cb-462e-9055-96e1441e1a09',
  standard: {
    monthly: '90f4704e-14eb-471b-beb8-fea990dc472b',
    annually: '587ab69c-1dd3-4ed4-be7e-a7684c55e6e3',
  },
  premium: {
    monthly: '91657e56-5a75-4702-bf29-a3112849024a',
    annually: 'fc31a0f7-514b-42b2-9818-f633c7d07239',
  },
};

type Packages = {
  payAsYouGo: any;
  standard: { monthly: any; annually: any };
  premium: { monthly: any; annually: any };
};

const styles: any = stylesModule;
type Props = {
  onSelect?: (value: {
    subscription: string;
    monthly?: boolean;
    planId?: string;
    packageId?: string;
  }) => void;
  recruiterId?: string;
  planName?: string;
  hideSubscribe?: boolean;
  exchangeRate: number;
  package?: any;
};
//temporary component for subscription model
export const RecruiterSubscriptionTable: FC<Props> = (props) => {
  const { onSelect, recruiterId, hideSubscribe, exchangeRate } = props;
  const [monthly, setMonthly] = useState(true);
  const [lkr, setLKR] = useState(true);
  const [amount0, setAmount0] = useState(0);
  const [amount1, setAmount1] = useState(12500);
  const [amount2, setAmount2] = useState(35000);
  const [month, setMonth] = useState('#009E60');
  const [year, setYear] = useState('#5A5D65');
  const [slColor, setSLColor] = useState('#A41E2C');
  const [usColor, setUSColor] = useState('#6A6A6A');
  const [currencytogglecolor, setcurrencyTogglecolor] = useState('#A41E2C');
  const [monthsize, setMonthsize] = useState(600);
  const [yearsize, setYearsize] = useState(200);
  const [packages, setPackages] = useState<Packages>({} as any);
  const [currentPackage, setCurrentPackage] = useState<any>();
  const [downgradeVisible, setDowngradeVisible] = useState(false);
  const [downgradeVisible1, setDowngradeVisible1] = useState(false);
  const [upgradeVisible, setUpgradeVisible] = useState(false);
  const [upgradeVisible1, setUpgradeVisible1] = useState(false);
  const [billingCycle, setBillingCycle] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState<any>();
  const [reqDemo, setReqDemo] = useState('');
  console.log(reqDemo, packages, hideSubscribe);
  const history = useRouter();
  const demostandard = useRef<RequestDemoInstance>(null);
  const demopremium = useRef<RequestDemoInstance>(null);
  const demo = useRef<RequestDemoInstance>(null);

  //const { masterdata, mainType,enumValue } = useCachedData();
  // console.log('masterdata', context.enumValue?.['Currency']);
  const connection = useConnection();

  const onChange = useCallback((checked: boolean) => {
    if (!checked) {
      setMonthly(true);
      setAmount0(0);
      setAmount1(12500);
      setAmount2(35000);
      setYear('#5A5D65');
      setMonth('#009E60');
      setMonthsize(600);
      setYearsize(200);
    } else {
      setMonthly(false);
      setAmount1(99999);
      setAmount2(299999);
      setMonth('#5A5D65');
      setYear('#009E60');
      setMonthsize(200);
      setYearsize(600);
    }
  }, []);

  const onChangeCurr = useCallback((checked: boolean) => {
    if (checked) {
      setLKR(false);
      setSLColor('#6A6A6A');
      setUSColor('#002565');
      setcurrencyTogglecolor('#002565');
      // setAmount0('USD 0/-');
      // setAmount1(`USD ${Number(amount1.replace(/[^0-9.-]+/g, '')) / 320}`);
      // setAmount2(`USD ${Number(amount2.replace(/[^0-9.-]+/g, '')) / 320}`);

      // setYear('#5A5D65');
      // setMonth('#009E60');
      // setMonthsize(600);
      // setYearsize(200);
    } else {
      setLKR(true);
      setSLColor('#A41E2C');
      setUSColor('#6A6A6A');
      setcurrencyTogglecolor('#A41E2C');
      // setAmount0('Rs 0/-');
      // setAmount1(`Rs ${Number(amount1.replace(/[^0-9.-]+/g, '')).toLocaleString('en-IN')}`);
      // setAmount2(`Rs ${Number(amount2.replace(/[^0-9.-]+/g, '')).toLocaleString('en-IN')}`);

      // setAmount1('LKR 102,000');
      // setAmount2('LKR 300,000');
      // setMonth('#5A5D65');
      // setYear('#009E60');
      // setMonthsize(200);
      // setYearsize(600);
    }
  }, []);

  const getPackages = useCallback(async () => {
    try {
      connection.get('packages').then((res) => {
        const pkgs = Object.fromEntries(res.map((v) => [v.key, v]));
        setPackages({
          payAsYouGo: pkgs[AvailablePackages.payAsYouGo],
          standard: {
            monthly: pkgs[AvailablePackages.standard.monthly],
            annually: pkgs[AvailablePackages.standard.annually],
          },
          premium: {
            monthly: pkgs[AvailablePackages.premium.monthly],
            annually: pkgs[AvailablePackages.premium.annually],
          },
        });
      });
    } catch (e) {
      console.log('Error', e);
    }
  }, [connection]);

  const getCurrentPackage = useCallback(() => {
    try {
      connection.post('package', { planId: props.package?.subscriptionId }).then((res) => {
        setCurrentPackage(res);
        setMonthly(res.billing !== 'Annually');
        onChange(res.billing === 'Annually');
      });
    } catch (e) {
      console.log('Error', e);
    }
  }, [connection, onChange, props.package?.subscriptionId]);

  useEffect(() => {
    getPackages().catch(console.error);
    getCurrentPackage();
  }, [getCurrentPackage, getPackages]);

  //   if (!packages.payAsYouGo || !currentPackage) {
  //     return <Spin spinning={true} />;
  //   }
  return (
    <div className={styles.tablecontainer}>
      <div className={styles.togglesContainer}>
        <div className={styles.toggleItem}>
          {' '}
          <p className={styles.tableSubtitle} style={{ color: month, fontWeight: monthsize }}>
            Monthly
          </p>{' '}
          <Space> </Space>{' '}
          <Switch
            className={styles.togglecolor}
            checked={!monthly}
            onChange={onChange}
            // size={'small'}
          />{' '}
          <Space> </Space>
          <p className={styles.tableSubtitle} style={{ color: year, fontWeight: yearsize }}>
            {' '}
            Yearly
          </p>
        </div>
        <Divider
          className={styles.currencyToggleContainer}
          style={{ height: '60%' }}
          type="vertical"
        />
        <div className={styles.currencyToggleContainer}>
          <div className={styles.toggleItem}>
            {' '}
            <p
              className={styles.tableSubtitle}
              style={{
                color: slColor,
                fontWeight: !lkr ? 200 : 'bolder',
                gap: '5px',
                display: 'flex',
              }}>
              <Image
                className={styles.flagicon}
                height={25}
                width={25}
                src={SLFlag}
                alt={'SL Flag'}
              />{' '}
              LKR
            </p>{' '}
            <Space> </Space>{' '}
            <Switch
              style={{ backgroundColor: currencytogglecolor }}
              // className={styles.togglecolor}
              checked={!lkr}
              onChange={onChangeCurr}
              // size={'small'}
            />{' '}
            <Space> </Space>
            <p
              className={styles.tableSubtitle}
              style={{
                color: usColor,
                fontWeight: lkr ? 200 : 'bolder',
                gap: '5px',
                display: 'flex',
              }}>
              {' '}
              <Image
                className={styles.flagicon}
                height={25}
                width={25}
                src={USFlag}
                alt={'US Flag'}
              />{' '}
              USD
            </p>
          </div>
        </div>
      </div>
      {/* plans */}
      <div className={styles.pricingPlanContainer}>
        <div
          style={{
            background: 'rgb(183, 227, 205,0.5)',
            borderTop: '10px solid #009E52',
            borderBottom: 'none',
            borderLeft: 'none',
            borderRight: 'none',
          }}
          className={styles.pricingPlan}>
          <div className={styles.headpay}>
            <span className={styles.pckgName}>
              <span style={{ width: '100%' }}>PAY AS YOU GO</span>
              <Tag
                className={styles.mobileCurrencyToggle}
                color="rgba(183, 227, 205, 0.3)"
                style={{
                  color: '#009E52',
                }}>
                <span className={styles.currecyToggleSpan}>
                  LKR
                  <Switch
                    style={{ backgroundColor: '#002565' }}
                    // className={styles.togglecolor}
                    checked={!lkr}
                    onChange={onChangeCurr}
                    size={'small'}
                  />{' '}
                  USD
                </span>
              </Tag>{' '}
            </span>
            <p className={styles.pckgDesc}>No monthly cost, only pay per job ad posted</p>

            <span className={styles.price}>
              {lkr ? 'Rs' : 'USD'} {amount0}/-
            </span>
            <span className={styles.per}>{monthly ? 'Per month' : 'Per annum'}</span>
          </div>
          <div>
            <Button
              size={'large'}
              icon={<PlusOutlined />}
              type={'primary'}
              onClick={() => history.push('/recruiter/create')}
              className={styles.planBtn}>
              <b style={{ fontWeight: 'bolder', marginLeft: '10px' }}>Post a Job</b>
            </Button>
          </div>
          {/* //features */}
          <div className={styles.featurescontainer}>
            {/* 1stpoint */}
            <div style={{ display: 'flex', gap: '20px' }}>
              <div className={styles.amountvalue}>
                <CheckOutlined style={{ color: '#1FAA77', strokeWidth: 100, stroke: '#1FAA77' }} />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span className={styles.amountvalue}>LKR 2000 | USD 4.99 Per ad</span>
                <span className={styles.amountvalue}>
                  <span style={{ color: '#C26566', textDecoration: 'line-through' }}>
                    LKR 4000 | USD 9.99
                  </span>
                  <Tag
                    color="#FFE87A"
                    style={{
                      color: 'black',
                      letterSpacing: '0.14px',
                      marginLeft: '10px',
                      fontSize: '14px',
                    }}>
                    50% off
                  </Tag>
                </span>
              </div>
            </div>
            {/* 2ndpoint */}
            <div style={{ display: 'flex', gap: '20px' }}>
              <div className={styles.amountvalue}>
                <CheckOutlined style={{ color: '#1FAA77', strokeWidth: 100, stroke: '#1FAA77' }} />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span className={styles.amountvalue}>2 weeks per ad</span>
              </div>
            </div>
            {/* 3ndpoint */}
            <div style={{ display: 'flex', gap: '20px' }}>
              <div className={styles.amountvalue}>
                <CheckOutlined style={{ color: '#1FAA77', strokeWidth: 100, stroke: '#1FAA77' }} />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span className={styles.amountvalue}>
                  Boost ad <sup style={{ top: '-.5em', position: 'relative' }}>1</sup> - Rs 250
                </span>
              </div>
            </div>
            {/* 4ndpoint */}
            <div style={{ display: 'flex', gap: '20px' }}>
              <div className={styles.amountvalue}>
                <CheckOutlined style={{ color: '#1FAA77', strokeWidth: 100, stroke: '#1FAA77' }} />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span className={styles.amountvalue}>5 Team Members</span>
              </div>
            </div>
            {/* 5ndpoint */}
            <div style={{ display: 'flex', gap: '20px' }}>
              <div className={styles.amountvalue}>
                <CheckOutlined style={{ color: '#1FAA77', strokeWidth: 100, stroke: '#1FAA77' }} />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span className={styles.amountvalue}>ATS</span>
              </div>
            </div>
            {/* 6ndpoint */}
            <div style={{ display: 'flex', gap: '20px' }}>
              <div className={styles.amountvalue}>
                <CheckOutlined style={{ color: '#1FAA77', strokeWidth: 100, stroke: '#1FAA77' }} />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span className={styles.amountvalue}>Unlimited applicants</span>
              </div>
            </div>
          </div>
        </div>
        {/* 2nd pricng plan container */}
        <div
          style={
            {
              // background: '#B7E3CD',
              // borderTop: '10px solid #009E52',
              // borderBottom: 'none',
              // borderLeft: 'none',
              // borderRight: 'none',
            }
          }
          className={styles.pricingPlan}>
          <div className={styles.headpay}>
            <span className={styles.pckgName}>
              <span style={{ width: '100%' }}>Standard</span>
              <Tag
                className={styles.mobileCurrencyToggle}
                color="rgba(183, 227, 205, 0.3)"
                style={{
                  backgroundColor: 'white',
                  color: '#009E52',
                }}>
                <span className={styles.currecyToggleSpan}>
                  LKR
                  <Switch
                    style={{ backgroundColor: '#002565' }}
                    // className={styles.togglecolor}
                    checked={!lkr}
                    onChange={onChangeCurr}
                    size={'small'}
                  />{' '}
                  USD
                </span>
              </Tag>{' '}
            </span>
            <p className={styles.pckgDesc}>For low volume hiring</p>

            <h1 className={styles.price}>
              {lkr ? 'Rs' : 'USD'}{' '}
              {lkr ? Number(amount1).toLocaleString('en-IN') : Math.floor(amount1 / exchangeRate)}/-
            </h1>
            <span className={styles.per}>{monthly ? 'Per month' : 'Per annum'}</span>
          </div>
          <div>
            <Button
              size={'large'}
              type={'primary'}
              onClick={() => {
                setReqDemo('standard');
                demostandard.current?.show();
              }}
              className={styles.requestDemoBtn}>
              <b>
                Request a Demo <RightOutlined className={styles.arrow} />
              </b>
            </Button>
          </div>
          {/* //features */}
          <div className={styles.featurescontainer}>
            {/* 1stpoint */}
            <div style={{ display: 'flex', gap: '20px' }}>
              <div className={styles.amountvalue}>
                <CheckOutlined style={{ color: '#1FAA77', strokeWidth: 100, stroke: '#1FAA77' }} />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span className={styles.amountvalue}>10 ads per month</span>
              </div>
            </div>
            {/* 2ndpoint */}
            <div style={{ display: 'flex', gap: '20px' }}>
              <div className={styles.amountvalue}>
                <CheckOutlined style={{ color: '#1FAA77', strokeWidth: 100, stroke: '#1FAA77' }} />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span className={styles.amountvalue}>4 weeks per ad</span>
              </div>
            </div>
            {/* 3ndpoint */}
            <div style={{ display: 'flex', gap: '20px' }}>
              <div className={styles.amountvalue}>
                <CheckOutlined style={{ color: '#1FAA77', strokeWidth: 100, stroke: '#1FAA77' }} />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span className={styles.amountvalue}>Boost ad- Rs 250</span>
              </div>
            </div>
            {/* 4ndpoint */}
            <div style={{ display: 'flex', gap: '20px' }}>
              <div className={styles.amountvalue}>
                <CheckOutlined style={{ color: '#1FAA77', strokeWidth: 100, stroke: '#1FAA77' }} />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span className={styles.amountvalue}>15 Team Members</span>
              </div>
            </div>
            {/* 5ndpoint */}
            <div style={{ display: 'flex', gap: '20px' }}>
              <div className={styles.amountvalue}>
                <CheckOutlined style={{ color: '#1FAA77', strokeWidth: 100, stroke: '#1FAA77' }} />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span className={styles.amountvalue}>ATS</span>
              </div>
            </div>
            {/* 6ndpoint */}
            <div style={{ display: 'flex', gap: '20px' }}>
              <div className={styles.amountvalue}>
                <CheckOutlined style={{ color: '#1FAA77', strokeWidth: 100, stroke: '#1FAA77' }} />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span className={styles.amountvalue}>Unlimited applicants</span>
              </div>
            </div>
            {/* 7ndpoint */}
            <div style={{ display: 'flex', gap: '20px' }}>
              <div className={styles.amountvalue}>
                <CheckOutlined style={{ color: '#1FAA77', strokeWidth: 100, stroke: '#1FAA77' }} />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span className={styles.amountvalue}>Recruiter Analytics</span>
              </div>
            </div>
          </div>
        </div>
        {/* 3rd pricng plan container */}
        <div
          style={
            {
              // background: '#B7E3CD',
              // borderTop: '10px solid #009E52',
              // borderBottom: 'none',
              // borderLeft: 'none',
              // borderRight: 'none',
            }
          }
          className={styles.pricingPlan}>
          <div className={styles.headpay}>
            <span className={styles.pckgName}>
              <span style={{ width: '100%' }}>Premium </span>
              <Tag
                className={styles.popularTag}
                color="rgba(183, 227, 205, 0.3)"
                style={{ color: '#009E52', letterSpacing: '0.3px', borderRadius: '15px' }}>
                Popular
              </Tag>{' '}
              <Tag
                className={styles.mobileCurrencyToggle}
                color="rgba(183, 227, 205, 0.3)"
                style={{
                  backgroundColor: 'white',
                  color: '#009E52',
                }}>
                <span className={styles.currecyToggleSpan}>
                  LKR
                  <Switch
                    style={{ backgroundColor: '#002565' }}
                    // className={styles.togglecolor}
                    checked={!lkr}
                    onChange={onChangeCurr}
                    size={'small'}
                  />{' '}
                  USD
                </span>
              </Tag>{' '}
            </span>
            <p className={styles.pckgDesc}>For high volume hiring</p>

            <h1 className={styles.price}>
              {lkr ? 'Rs' : 'USD'}{' '}
              {lkr
                ? Number(amount2)
                    .toLocaleString('en-IN', {
                      maximumFractionDigits: 0,
                      minimumFractionDigits: 0,
                      useGrouping: false,
                    })
                    .replace(/^(\d+)$/, '$1')
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                : Math.floor(amount2 / exchangeRate)}
              /-
            </h1>
            <span className={styles.per}>{monthly ? 'Per month' : 'Per annum'}</span>
          </div>
          <div>
            <Button
              size={'large'}
              type={'primary'}
              onClick={() => {
                demopremium.current?.show();
              }}
              className={styles.requestDemoBtn}>
              <b>
                Request a Demo <RightOutlined className={styles.arrow} />
              </b>
            </Button>
          </div>
          {/* //features */}
          <div className={styles.featurescontainer}>
            {/* 1stpoint */}
            <div style={{ display: 'flex', gap: '20px' }}>
              <div className={styles.amountvalue}>
                <CheckOutlined style={{ color: '#1FAA77', strokeWidth: 100, stroke: '#1FAA77' }} />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span className={styles.amountvalue}>Unlimited ads per month</span>
              </div>
            </div>
            {/* 2ndpoint */}
            <div style={{ display: 'flex', gap: '20px' }}>
              <div className={styles.amountvalue}>
                <CheckOutlined style={{ color: '#1FAA77', strokeWidth: 100, stroke: '#1FAA77' }} />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span className={styles.amountvalue}>4 weeks per ad</span>
              </div>
            </div>
            {/* 3ndpoint */}
            <div style={{ display: 'flex', gap: '20px' }}>
              <div className={styles.amountvalue}>
                <CheckOutlined style={{ color: '#1FAA77', strokeWidth: 100, stroke: '#1FAA77' }} />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span className={styles.amountvalue}>All ads boosted (Featured)</span>
              </div>
            </div>
            {/* 4ndpoint */}
            <div style={{ display: 'flex', gap: '20px' }}>
              <div className={styles.amountvalue}>
                <CheckOutlined style={{ color: '#1FAA77', strokeWidth: 100, stroke: '#1FAA77' }} />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span className={styles.amountvalue}>Unlimited team members</span>
              </div>
            </div>
            {/* 5ndpoint */}
            <div style={{ display: 'flex', gap: '20px' }}>
              <div className={styles.amountvalue}>
                <CheckOutlined style={{ color: '#1FAA77', strokeWidth: 100, stroke: '#1FAA77' }} />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span className={styles.amountvalue}>ATS</span>
              </div>
            </div>
            {/* 6ndpoint */}
            <div style={{ display: 'flex', gap: '20px' }}>
              <div className={styles.amountvalue}>
                <CheckOutlined style={{ color: '#1FAA77', strokeWidth: 100, stroke: '#1FAA77' }} />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span className={styles.amountvalue}>Unlimited applicants</span>
              </div>
            </div>
            {/* 7ndpoint */}
            <div style={{ display: 'flex', gap: '20px' }}>
              <div className={styles.amountvalue}>
                <CheckOutlined style={{ color: '#1FAA77', strokeWidth: 100, stroke: '#1FAA77' }} />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span className={styles.amountvalue}>Recruiter Analytics</span>
              </div>
            </div>
            {/* 8thpoint */}
            <div style={{ display: 'flex', gap: '20px' }}>
              <div className={styles.amountvalue}>
                <CheckOutlined style={{ color: '#1FAA77', strokeWidth: 100, stroke: '#1FAA77' }} />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span className={styles.amountvalue}>
                  Headhunting (Eyeballing){' '}
                  <sup style={{ top: '-.5em', position: 'relative' }}>2</sup>{' '}
                </span>
              </div>
            </div>
          </div>
        </div>
        <RequestDemoModal ref={demostandard} plan={'standard'} />
        <RequestDemoModal ref={demopremium} plan={'premium'} />
        <RequestDemoModal ref={demo} plan={'Demo'} />

        {/* <table className={styles.sub}>
          <tbody>
            <tr>
              <th className={styles.toggleth}>
          
              </th>
              <th className={styles.headpay} colSpan={2}>
                PAY AS YOU GO
              </th>
              <th className={styles.whiteborder} />
              <th className={styles.headsub} colSpan={3}>
                <Row>
                  <Col span={24} className={styles.tableTitleTxt}>
                    SUBSCRIPTION
                  </Col>
                  <Col span={24}>
                    <div className={styles.toggles}>
                      <p
                        className={styles.tableSubtitle}
                        style={{ color: month, fontWeight: monthsize }}>
                        Monthly
                      </p>{' '}
                      <Space> </Space>{' '}
                      <Switch
                        className={styles.togglecolor}
                        checked={!monthly}
                        onChange={onChange}
                        size={'small'}
                      />{' '}
                      <Space> </Space>
                      <p
                        className={styles.tableSubtitle}
                        style={{ color: year, fontWeight: yearsize }}>
                        {' '}
                        Yearly
                      </p>
                    </div>
                  </Col>
                </Row>
              </th>
            </tr>

            <tr>
              <th className={styles.secondcol} />
              <th colSpan={2} className={styles.head1}>
                <Row className={styles.secondRow}>
               
                  <Col span={24} className={styles.tableTitleTxt}>
                    No Monthly Cost
                  </Col>
                
                  <Col span={24} className={styles.amountvalue}>
                    LKR 2,000 Per Ad
                  </Col>
                  {!hideSubscribe && (
                    <Col span={24} style={{ paddingTop: '5px', textAlign: 'center' }}>
                      <Button
                        type="primary"
                        size="small"
                        onClick={() => {
                          if (currentPackage.key === AvailablePackages.payAsYouGo) {
                            return;
                          }
                          subChangeModal.current?.show(AvailablePackages.payAsYouGo);
                        }}
                        className={classNames({
                          [styles.buttonSelect]:
                            currentPackage.key !== AvailablePackages.payAsYouGo,
                        })}>
                        {currentPackage.key === AvailablePackages.payAsYouGo
                          ? 'SELECTED'
                          : 'SELECT'}
                      </Button>
                    </Col>
                  )}
                </Row>
              </th>

              <th className={styles.whiteborder} />

              <th className={styles.stand1}>
                <Row className={styles.secondRow}>
                  <Col span={24} className={styles.tableTitleTxt}>
                    STANDARD
                  </Col>
                  <Col span={24} className={styles.amountvalue}>
                    {amount1}
                  </Col>
                  {!hideSubscribe && (
                    <Col span={24} style={{ paddingTop: '5px' }}>
                      <Button
                        type="primary"
                        size="small"
                        onClick={() => {
                          if (
                            currentPackage.key ===
                            AvailablePackages.standard[monthly ? 'monthly' : 'annually']
                          ) {
                            return;
                          }
                          subChangeModal.current?.show(
                            AvailablePackages.standard[monthly ? 'monthly' : 'annually'],
                          );
                        }}
                        className={classNames({
                          [styles.buttonSelect]:
                            currentPackage.key !==
                            AvailablePackages.standard[monthly ? 'monthly' : 'annually'],
                        })}>
                        {currentPackage.key ===
                        AvailablePackages.standard[monthly ? 'monthly' : 'annually']
                          ? 'SELECTED'
                          : 'SELECT'}
                      </Button>
                    </Col>
                  )}
                </Row>
              </th>

              <th className={styles.stand}>
                <Row className={styles.secondRow}>
                  <Col span={24} className={styles.tableTitleTxt}>
                    PREMIUM
                  </Col>
                  <Col span={24} className={styles.amountvalue}>
                    {amount2}
                  </Col>
                  {!hideSubscribe && (
                    <Col span={24} style={{ paddingTop: '5px', textAlign: 'center' }}>
                      <Button
                        type="primary"
                        size="small"
                        onClick={() => {
                          if (
                            currentPackage.key ===
                            AvailablePackages.premium[monthly ? 'monthly' : 'annually']
                          ) {
                            return;
                          }
                          subChangeModal.current?.show(
                            AvailablePackages.premium[monthly ? 'monthly' : 'annually'],
                          );
                        }}
                        className={classNames({
                          [styles.buttonSelect]:
                            currentPackage.key !==
                            AvailablePackages.premium[monthly ? 'monthly' : 'annually'],
                        })}>
                        {currentPackage.key ===
                        AvailablePackages.premium[monthly ? 'monthly' : 'annually']
                          ? 'SELECTED'
                          : 'SELECT'}
                      </Button>
                    </Col>
                  )}
                </Row>
              </th>
            </tr>

            <tr>
              <td width={'34%'}>Number of free Job Ads</td>

              <td width={'31%'} className={styles.tddleft}>
                NONE
              </td>
              <td />
              <td width={'0.5%'} className={styles.whiteborder} />

              <td className={styles.tdd1} width={'17%'}>
                10 ads per month
              </td>

              <td width={'17%'} className={styles.lastborder}>
                UNLIMITED
              </td>
            </tr>

            <tr>
              <td>Price per Ad(LKR)</td>
              <td className={styles.tddleft}>
                <Row>
                  <Col span={24} className={styles.fontLucids}>
                    LKR <p className={styles.through}>4,000</p> (50% off)
                  </Col>
                  <Col span={24} className={styles.fontLucids}>
                    {' '}
                    LKR 2,000 per ad
                  </Col>
                </Row>
              </td>
              <td />
              <td className={styles.whiteborder} />

              <td className={styles.tdd1}>
                <Row>
                  <Col span={24}>
                    {' '}
                    LKR <p className={styles.through}>3,000</p> (50% off)
                  </Col>
                  <Col span={24} className={styles.fontLucids}>
                    {' '}
                    LKR 1,500 per ad<sup>1</sup>
                  </Col>
                </Row>
              </td>

              <td className={styles.lastborder}>UNLIMITED</td>
            </tr>

            <tr>
              <td>
                Featured Ads<sup>2</sup>
              </td>
              <td colSpan={2} className={styles.tddleft}>
                -
              </td>
              <td className={styles.whiteborder} />
              <td>-</td>

              <td className={styles.lastborder}>
                <CheckCircleFilled style={{ color: '#009E60', fontSize: '20px' }} />
              </td>
            </tr>

            <tr>
              <td>
                Price per Boosted Ad<sup>3</sup>
              </td>
              <td colSpan={2} className={styles.tddleft}>
                LKR 250
              </td>
              <td className={styles.whiteborder} />
              <td>LKR 250</td>

              <td className={styles.lastborder}>FEATURED</td>
            </tr>

            <tr>
              <td>
                Duration of Ad<sup>4</sup>
              </td>
              <td colSpan={2} className={styles.tddleft}>
                2 weeks
              </td>
              <td className={styles.whiteborder} />
              <td>4 weeks</td>

              <td className={styles.lastborder}>4 weeks</td>
            </tr>

            <tr>
              <td>Number of Applicants per Ad</td>
              <td colSpan={2} className={styles.tddleft}>
                UNLIMITED
              </td>
              <td className={styles.whiteborder} />
              <td>UNLIMITED</td>

              <td className={styles.lastborder}>UNLIMITED</td>
            </tr>

            <tr>
              <td>Job Applications Management Module</td>
              <td colSpan={2} className={styles.tddleft}>
                <CheckCircleFilled style={{ color: '#009E60', fontSize: '20px' }} />
              </td>
              <td className={styles.whiteborder} />
              <td>
                <CheckCircleFilled style={{ color: '#009E60', fontSize: '20px' }} />
              </td>

              <td className={styles.lastborder}>
                <CheckCircleFilled style={{ color: '#009E60', fontSize: '20px' }} />
              </td>
            </tr>

            <tr>
              <td>Applicant Emailing and Email Templates</td>
              <td colSpan={2} className={styles.tddleft}>
                <CheckCircleFilled style={{ color: '#009E60', fontSize: '20px' }} />
              </td>
              <td className={styles.whiteborder} />
              <td>
                <CheckCircleFilled style={{ color: '#009E60', fontSize: '20px' }} />
              </td>

              <td className={styles.lastborder}>
                <CheckCircleFilled style={{ color: '#009E60', fontSize: '20px' }} />
              </td>
            </tr>

            <tr>
              <td>Branded Recruiter Profile</td>
              <td colSpan={2} className={styles.tddleft}>
                <CheckCircleFilled style={{ color: '#009E60', fontSize: '20px' }} />
              </td>
              <td className={styles.whiteborder} />
              <td>
                <CheckCircleFilled style={{ color: '#009E60', fontSize: '20px' }} />
              </td>

              <td className={styles.lastborder}>
                <CheckCircleFilled style={{ color: '#009E60', fontSize: '20px' }} />
              </td>
            </tr>

            <tr>
              <td>Number of Team Members</td>
              <td colSpan={2} className={styles.tddleft}>
                5
              </td>
              <td className={styles.whiteborder} />
              <td>15</td>

              <td className={styles.lastborder}>UNLIMITED</td>
            </tr>

            <tr>
              <td>Download Job Applications</td>
              <td colSpan={2} className={styles.tddleft}>
                <CheckCircleFilled style={{ color: '#009E60', fontSize: '20px' }} />
              </td>
              <td className={styles.whiteborder} />
              <td>
                <CheckCircleFilled style={{ color: '#009E60', fontSize: '20px' }} />
              </td>

              <td className={styles.lastborder}>
                <CheckCircleFilled style={{ color: '#009E60', fontSize: '20px' }} />
              </td>
            </tr>

            <tr>
              <td>
                Export Applicants Lists<sup>5</sup>
              </td>
              <td colSpan={2} className={styles.tddleft}>
                -
              </td>
              <td className={styles.whiteborder} />
              <td>
                <CheckCircleFilled style={{ color: '#009E60', fontSize: '20px' }} />
              </td>

              <td className={styles.lastborder}>
                <CheckCircleFilled style={{ color: '#009E60', fontSize: '20px' }} />
              </td>
            </tr>

            <tr>
              <td>Recruiter Analytics</td>
              <td colSpan={2} className={styles.tddleft}>
                -
              </td>
              <td className={styles.whiteborder} />
              <td>
                <CheckCircleFilled style={{ color: '#009E60', fontSize: '20px' }} />
              </td>

              <td className={styles.lastborder}>
                <CheckCircleFilled style={{ color: '#009E60', fontSize: '20px' }} />
              </td>
            </tr>

            <tr>
              <td>
                Head Hunting (Eyeballing)<sup>6</sup>
              </td>
              <td colSpan={2} className={styles.lastboder1}>
                -
              </td>
              <td className={styles.whiteborder} />
              <td className={styles.lastboder2}>-</td>
              <td className={styles.lastboder3}>
                <CheckCircleFilled style={{ color: '#009E60', fontSize: '20px' }} />
              </td>
            </tr>
          </tbody>
        </table> */}
      </div>
      <br />
      <div className={styles.items}>
        <Row>
          <Col style={{ display: 'flex' }} span={24}>
            <sup style={{ paddingRight: '5px' }}>
              <b>1</b>
            </sup>
            <span style={{ marginTop: '5px', fontSize: '1.125rem', letterSpacing: '0.2px' }}>
              Increase the visibility of your advert for a week
            </span>
          </Col>
          <Col style={{ display: 'flex' }} span={24}>
            <sup style={{ paddingRight: '5px' }}>
              <b>2</b>
            </sup>
            <span style={{ marginTop: '5px', fontSize: '1.125rem', letterSpacing: '0.2px' }}>
              Headhunting - access our full candidate database to approach good candidates even
              without them applying for jobs
            </span>
          </Col>
        </Row>
      </div>
      <br />
      <br />
      <Typography style={{ color: '#212121', fontSize: '1.125rem' }} className="text-black-500">
        <b>Note:</b> if you wish to pay in USD or receive a custom quotation, please contact us via
        <a className="text-black" href={'tel:+94727360360'}>
          &nbsp;+94 727 360 360
        </a>{' '}
        or
        <a className="text-black" href={'mailto:info@careers360.lk'}>
          &nbsp;info@careers360.lk
        </a>{' '}
        for more details
      </Typography>
      {/* //got question banner */}
      <div className={styles.gotQBanner}>
        <div className={styles.gotQContentContainer}>
          <div className={styles.textContainer}>
            <span className={styles.gotQHeading}>Got a Question?</span>
            <span className={styles.gotQSubHeading}>
              Careers360 can help you recruit talent faster and efficiently.
              <br /> Let&apos;s discuss your hiring needs today.
            </span>
          </div>
          <div>
            {' '}
            <Button
              style={{
                marginTop: 0,
                width: '293px',
              }}
              size={'large'}
              type={'primary'}
              onClick={() => {
                demo.current?.show();
              }}
              className={styles.requestDemoBtngotQ}>
              <b style={{ fontWeight: 'bolder' }}>Request a Demo </b>
              <RightOutlined className={styles.arrow} />
            </Button>
          </div>
        </div>
      </div>
      {selectedPackage && (
        <div>
          <ResponsiveModal
            title={'Downgrade Subscription Plan'}
            visible={downgradeVisible}
            onCancel={() => {
              setDowngradeVisible(false);
              setSelectedPackage(undefined);
            }}
            okText={'Confirm'}
            onOk={() => {
              connection
                .post('subscription/downgrade', {
                  packageId: selectedPackage?.key,
                  recruiterId: props.recruiterId,
                })
                .then(async (res) => {
                  if (res.response.status === 'success') {
                    await Router.push({
                      pathname: `/recruiter/${recruiterId}/subscription-dashboard`,
                    });
                    window.location.reload();
                  }
                })
                .finally(() => {
                  setDowngradeVisible(false);
                  setSelectedPackage(undefined);
                });
            }}>
            <div style={{ textAlign: 'center', marginBottom: 6 }}>
              <span>
                You’re about to downgrade your plan from{' '}
                <span style={{ fontWeight: 'bold' }}>{currentPackage?.name}</span> to{' '}
                <span style={{ fontWeight: 'bold' }}>PAY AS YOU GO</span>
              </span>
            </div>
            <div style={{ textAlign: 'center', marginBottom: 6 }}>
              <span style={{ fontSize: 14 }}>
                You will be downgraded to the new subscription plan and will be charged with the
                total amount of the new downgraded plan at the beginning of the next billing cycle
              </span>
            </div>
            <div style={{ textAlign: 'center' }}>
              <span style={{ fontSize: 14 }}>
                Once the subscription plan downgrade is confirmed, you will not be able to change
                the subscription again until the new subscription plan is activated at the beginning
                of the next billing cycle
              </span>
            </div>
          </ResponsiveModal>
          <ResponsiveModal
            title={'Downgrade Subscription Plan'}
            visible={downgradeVisible1}
            onCancel={() => {
              setDowngradeVisible1(false);
              setSelectedPackage(undefined);
            }}
            okText={'Confirm'}
            onOk={() => {
              connection
                .post('subscription/downgrade', {
                  packageId: selectedPackage?.key,
                  recruiterId: props.recruiterId,
                })
                .then(async (res) => {
                  if (res.response.status === 'success') {
                    await Router.push({
                      pathname: `/recruiter/${recruiterId}/subscription-dashboard`,
                    });
                    window.location.reload();
                  }
                })
                .finally(() => {
                  setDowngradeVisible1(false);
                  setSelectedPackage(undefined);
                });
            }}>
            <div style={{ textAlign: 'center', marginBottom: 6 }}>
              <span>
                You’re about to downgrade your plan from{' '}
                <span style={{ fontWeight: 'bold' }}>{currentPackage?.name}</span> to{' '}
                <span style={{ fontWeight: 'bold' }}>{selectedPackage?.name}</span>
              </span>
            </div>
            <div style={{ textAlign: 'center', marginBottom: 6 }}>
              <span style={{ fontSize: 14 }}>
                You will be downgraded to the new subscription plan and will be charged with the
                total amount of the new downgraded plan at the beginning of the next billing cycle
              </span>
            </div>
            <Space direction={'vertical'} style={{ marginLeft: 22 }}>
              <Space direction={'vertical'}>
                <span style={{ fontWeight: 'bold' }}>New Billing Amount</span>
                <span style={{ fontWeight: 500 }}>
                  LKR{' '}
                  {monthly
                    ? Utils.formatNumber(selectedPackage?.price, 0) + ' (Billed Monthly)'
                    : Utils.formatNumber(selectedPackage?.price, 0) + ' (Billed Annually)'}
                </span>
              </Space>
              <Space direction={'vertical'}>
                <span style={{ fontWeight: 'bold' }}>Billing Period</span>
                <span style={{ fontWeight: 500 }}>
                  {monthly
                    ? moment(props?.package?.renewalDate).format('MMM Do YYYY') +
                      ' to ' +
                      moment(props?.package?.renewalDate).add(1, 'months').format('MMM Do YYYY')
                    : moment(props?.package?.renewalDate).format('MMM Do YYYY') +
                      ' to ' +
                      moment(props?.package?.renewalDate).add(1, 'years').format('MMM Do YYYY')}
                </span>
              </Space>
            </Space>
            <div style={{ textAlign: 'center' }}>
              <span style={{ fontSize: 14, color: 'red' }}>
                Once the subscription plan downgrade is confirmed, you will not be able to change
                the subscription again until the new subscription plan is activated at the beginning
                of the next billing cycle
              </span>
            </div>
          </ResponsiveModal>
          <ResponsiveModal
            title={'Upgrade Subscription Plan'}
            open={upgradeVisible1}
            onCancel={() => {
              setUpgradeVisible1(false);
              setSelectedPackage(undefined);
            }}
            okText={'Upgrade'}
            onOk={() => {
              if (onSelect) {
                onSelect?.({
                  subscription: selectedPackage?.name,
                  monthly: monthly,
                  packageId: selectedPackage?.key,
                });
              } else {
                if (recruiterId) {
                  Router.push({
                    pathname: `/recruiter/${recruiterId}/payment`,
                    query: {
                      monthly: monthly,
                      packageId: selectedPackage?.key,
                      price: (
                        selectedPackage?.price *
                          (moment(props.package?.renewalDate).diff(moment(), 'days') / 365) -
                        currentPackage?.price *
                          (moment(props.package?.renewalDate).diff(moment(), 'days') / 365)
                      ).toFixed(0),
                    },
                  });
                }
              }
            }}>
            <div style={{ textAlign: 'center', marginBottom: 6 }}>
              <span>
                You’re about to upgrade your plan from{' '}
                <span style={{ fontWeight: 'bold' }}>{currentPackage?.name}</span> to{' '}
                <span style={{ fontWeight: 'bold' }}>{selectedPackage?.name}</span>
              </span>
            </div>
            <div style={{ textAlign: 'center', marginBottom: 6 }}>
              <span style={{ fontSize: 14 }}>
                The Standard Annual Plan subscription fee for the current usage will be deducted
                from the Premium Annual Plan subscription fee and only the prorated total due for
                the upgrade will be charged
              </span>
            </div>
            <Space direction={'vertical'} style={{ marginLeft: 22 }}>
              <Row
                className={styles.proratedBox}
                gutter={[0, 16]}
                justify="space-around"
                align="middle">
                <Col span={12}>
                  <span>
                    Premium Annual Plan subscription fee × <br />
                    (days left in subscription term / 365)
                  </span>
                </Col>
                <Col span={2}>
                  <span>=</span>
                </Col>
                <Col span={8}>
                  <span>
                    {'LKR ' +
                      selectedPackage?.price +
                      ' × ' +
                      '(' +
                      moment(props.package?.renewalDate).diff(moment(), 'days') +
                      '/ 365)'}
                  </span>
                </Col>

                <Col span={12}>
                  <span>
                    (-) Standard Annual Plan subscription fee × <br /> (days left in subscription
                    term / 365)
                  </span>
                </Col>
                <Col span={2}>
                  <span>=</span>
                </Col>
                <Col span={8}>
                  <span>
                    {'LKR ' +
                      currentPackage?.price +
                      ' × ' +
                      '(' +
                      moment(props.package?.renewalDate).diff(moment(), 'days') +
                      '/ 365)'}
                  </span>
                </Col>

                <Col span={12}>
                  <span>Prorated Total</span>
                </Col>
                <Col span={2}>
                  <span>=</span>
                </Col>
                <Col span={8}>
                  <span>
                    {'LKR ' +
                      (
                        selectedPackage?.price *
                          (moment(props.package?.renewalDate).diff(moment(), 'days') / 365) -
                        currentPackage?.price *
                          (moment(props.package?.renewalDate).diff(moment(), 'days') / 365)
                      ).toFixed(0)}
                  </span>
                </Col>
              </Row>
              <Space direction={'vertical'}>
                <span style={{ fontWeight: 'bold' }}>Billing Period</span>
                <span style={{ fontWeight: 500 }}>
                  {moment().format('MMM Do YYYY') +
                    ' to ' +
                    moment().add(1, 'years').format('MMM Do YYYY')}
                </span>
              </Space>
            </Space>
          </ResponsiveModal>
          <ResponsiveModal
            title={'Upgrade Subscription Plan'}
            open={upgradeVisible}
            onCancel={() => {
              setUpgradeVisible(false);
              setSelectedPackage(undefined);
            }}
            okText={'Upgrade'}
            onOk={() => {
              if (onSelect) {
                onSelect?.({
                  subscription: selectedPackage?.name,
                  monthly: monthly,
                  packageId: selectedPackage?.key,
                });
              } else {
                if (recruiterId) {
                  Router.push({
                    pathname: `/recruiter/${recruiterId}/payment`,
                    query: {
                      monthly: monthly,
                      packageId: selectedPackage?.key,
                    },
                  });
                }
              }
            }}>
            <div>
              <div style={{ textAlign: 'center', marginBottom: 6 }}>
                <span>
                  You’re about to upgrade your plan from{' '}
                  <span style={{ fontWeight: 'bold' }}>{currentPackage?.name}</span> to{' '}
                  <span style={{ fontWeight: 'bold' }}>{selectedPackage?.name}</span>
                </span>
              </div>
              <div style={{ textAlign: 'center', marginBottom: 6 }}>
                <span style={{ fontSize: 14 }}>
                  You will be upgraded to the new subscription plan instantly and will be charged
                  with the total amount of the new upgraded plan
                </span>
              </div>
              <Space direction={'vertical'} style={{ marginLeft: 22 }}>
                <Space direction={'vertical'}>
                  <span style={{ fontWeight: 'bold' }}>New Billing Amount</span>
                  <span style={{ fontWeight: 500 }}>
                    LKR{' '}
                    {monthly
                      ? Utils.formatNumber(selectedPackage?.price, 0) + ' (Billed Monthly)'
                      : Utils.formatNumber(selectedPackage?.price, 0) + ' (Billed Annually)'}
                  </span>
                </Space>
                <Space direction={'vertical'}>
                  <span style={{ fontWeight: 'bold' }}>Billing Period</span>
                  <span style={{ fontWeight: 500 }}>
                    {monthly
                      ? moment().format('MMM Do YYYY') +
                        ' to ' +
                        moment().add(1, 'months').format('MMM Do YYYY')
                      : moment().format('MMM Do YYYY') +
                        ' to ' +
                        moment().add(1, 'years').format('MMM Do YYYY')}
                  </span>
                </Space>
              </Space>
            </div>
          </ResponsiveModal>
          <ResponsiveModal
            title={'Change Billing Cycle'}
            open={billingCycle}
            onCancel={() => {
              setBillingCycle(false);
              setSelectedPackage(undefined);
            }}
            okText={'Confirm'}
            onOk={() => {
              connection
                .post('subscription/downgrade', {
                  packageId: selectedPackage?.key,
                  recruiterId: props.recruiterId,
                })
                .then(async (res) => {
                  if (res.response.status === 'success') {
                    await Router.push({
                      pathname: `/recruiter/${recruiterId}/subscription-dashboard`,
                    });
                    window.location.reload();
                  }
                })
                .finally(() => {
                  setBillingCycle(false);
                  setSelectedPackage(undefined);
                });
            }}>
            <div style={{ textAlign: 'center', marginBottom: 6 }}>
              <span>
                You’re about to change your billing cycle from{' '}
                <span style={{ fontWeight: 'bold' }}>{currentPackage?.name}</span>
                <span style={{ fontWeight: 'bold' }}>
                  {!monthly ? '- Monthly Billing Cycle ' : ' - Annual Billing Cycle '}
                </span>
                to <span style={{ fontWeight: 'bold' }}>{selectedPackage?.name}</span>
              </span>
            </div>
            <div style={{ textAlign: 'center', marginBottom: 6 }}>
              <span style={{ fontSize: 14 }}>
                Your billing cycle will be changed and will be charged with the total amount of the
                selected subscription plan for the new billing period instantly.
              </span>
            </div>
            <Space direction={'vertical'} style={{ marginLeft: 22 }}>
              <Space direction={'vertical'}>
                <span style={{ fontWeight: 'bold' }}>New Billing Amount</span>
                <span style={{ fontWeight: 500 }}>
                  LKR{' '}
                  {monthly
                    ? Utils.formatNumber(selectedPackage?.price, 0) + ' (Billed Monthly)'
                    : Utils.formatNumber(selectedPackage?.price, 0) + ' (Billed Annually)'}
                </span>
              </Space>
              <Space direction={'vertical'}>
                <span style={{ fontWeight: 'bold' }}>Billing Period</span>
                <span style={{ fontWeight: 500 }}>
                  {monthly
                    ? moment(props?.package?.renewalDate).format('MMM Do YYYY') +
                      ' to ' +
                      moment(props?.package?.renewalDate).add(1, 'months').format('MMM Do YYYY')
                    : moment(props?.package?.renewalDate).format('MMM Do YYYY') +
                      ' to ' +
                      moment(props?.package?.renewalDate).add(1, 'years').format('MMM Do YYYY')}
                </span>
              </Space>
            </Space>
            <div style={{ textAlign: 'center' }}>
              <span style={{ fontSize: 14, color: 'red' }}>
                Once the billing cycle change is confirmed, you will not be able to make any changes
                to the subscription again until the new billing cycle is activated at the beginning
                of the next billing cycle
              </span>
            </div>
          </ResponsiveModal>
        </div>
      )}
    </div>
  );
};
